import React, { useState } from "react";
import { Row, Col, Card, Collapse } from "react-bootstrap";
import { BsPlus, BsDash } from "react-icons/bs";

const supportItems = [
  {
    title: "Victims of Domestic Abuse",
    content: "We assist AFSSA in supporting survivors of domestic violence and sexual assault.",
    link: "https://www.afssaustin.org/"
  },
  {
    title: "Meals On Wheels",
    content: "We support the non-profit Meals on Wheels Central Texas, which provides meals to seniors and others in need.",
    link: "https://www.mealsonwheelscentraltexas.org/"
  },
  {
    title: "Feed The Homeless",
    content: "We support the distribution of meals to the local homeless community."
  },
  {
    title: "Natural Disaster Relief",
    content: "We support emergency relief efforts for victims of natural disasters, providing essential aid and shelter."
  },
  {
    title: "Free Clinics",
    content: "We support EHS in providing high-quality, affordable healthcare to underserved communities.",
    link: "http://www.ehsclinic.org"
  },
  {
    title: "Ummul Khairy Orphanage",
    content: "We support Ummul Khairy Orphanage in providing care and support for orphans.",
    link: "https://ukhorphans.net/"
  },
  {
    title: "Drive A Senior",
    content: "We support Chariot (Drive a Senior), an organization that delivers senior transportation services.",
    link: "https://chariot.org/donate/"
  },
  {
    title: "Revert Umrah Program",
    content: "We support the Revert Umrah program, helping and funding low-income reverts perform Umrah."
  },
  {
    title: "Low Income Students",
    content: (
      <>
        We support low-income students at local Islamic schools:
        <br />
        <a href="https://racademy.org" target="_blank" rel="noopener noreferrer">Renaissance Academy</a><br />
        <a href="https://www.apacademy.org/" target="_blank" rel="noopener noreferrer">Austin Peace Academy</a>
      </>
    )
  },
  {
    title: "Darul Uloom Austin",
    content: "We support Darul Uloom, an institution providing Quran memorization programs.",
    link: "https://www.darululoomaustin.org/"
  },
  {
    title: "Deen Intensive",
    content: "We support Deen Intensive, a weekend Islamic conference organized by UT students.",
    link: "https://texasdeenintensive.com/"
  },
  {
    title: "Nueces Reconstruction",
    content: "We support the Nueces Mosque in its reconstruction efforts to serve the community better.",
    link: "/Nueces"
  },
  {
    title: "ICGA Cemetery",
    content: "We assist ICGA Cemetery in providing dignified burial services for the Muslim community.",
    link: "https://www.icgamuslimcemetery.org/"
  }
];

const ExpandableCard = ({ title, content, link }) => {
  const [open, setOpen] = useState(false);

  return (
    <Card
      onClick={() => setOpen(!open)}
      className="shadow mb-3"
      style={{
        border: "1px solid #336633",
        cursor: "pointer",
        backgroundColor: "white",
        transition: "all 0.3s ease"
      }}
    >
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="m-0" style={{ fontWeight: 600 }}>{title}</h5>
          {open ? <BsDash size={24} color="#336633" /> : <BsPlus size={24} color="#336633" />}
        </div>
        <Collapse in={open}>
          <div className="mt-2 text-start" style={{ fontSize: "16px" }}>
            {typeof content === "string" ? <p>{content}</p> : content}
            {link && (
              <a href={link} target="_blank" rel="noopener noreferrer">Learn More</a>
            )}
          </div>
        </Collapse>
      </Card.Body>
    </Card>
  );
};

const ExpandableCardList = () => (
  <>
    <Row className="justify-content-center">
      {supportItems.map((item, index) => (
        <Col key={index} md={4} sm={6} xs={12}>
          <ExpandableCard {...item} />
        </Col>
      ))}
    </Row>
  </>
);

export default ExpandableCardList;
